const debounce = function (func, time = 100) {
  let timeVal = time;
  let timer;

  return function(e) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(func, timeVal, e);
  };
};

export default debounce;